import { ValidatorInput } from '../../../../model.module/validation/validation-descriptor.entity';
import { ValidationChecks } from '../../../../model.module/validation/validation-checks.enum';
import { ValidationError } from '../../../../model.module/validation/validation.error';
import { Validator } from '../../../../model.module/validation/validator.util';

export class ObligoAbrufModel {

    vsnrSelection = new ValidatorInput(
        'vsnrSelection',
        '',
        'Versicherungsschein-Nr.',
        /^.*$/,
        null,
        false,
        ValidationChecks.NOT_EMPTY_CHECK,
    );

    onlyInRisk = new ValidatorInput(
        'onlyInRisk',
        'im_risiko',
        'Obligoliste umfasst',
        /^(im_risiko|alle)$/,
        null,
        false,
        ValidationChecks.CUSTOM_REGEX_CHECK,
    );

    requiredFormat = new ValidatorInput(
        'requiredFormat',
        'csv',
        'Liste herunterladen als',
        /^(csv|pdf)$/,
        null,
        false,
        ValidationChecks.CUSTOM_REGEX_CHECK,
    );

    datumVon = new ValidatorInput(
        'datumVon',
        '',
        'Bürgschaften vom',
        /^.*$/,
        null,
        false,
        0,
        this.checkVonBisDate.bind(this),
    );

    datumBis = new ValidatorInput(
        'datumBis',
        '',
        'Bürgschaften bis',
        /^.*$/,
        null,
        false,
        0,
        this.checkVonBisDate.bind(this)
    );

    private collection: ValidatorInput[] = [
        this.vsnrSelection,
        this.onlyInRisk,
        this.requiredFormat,
        this.datumVon,
        this.datumBis
    ];

    public validateAll(): ValidationError[] {
        const result: ValidationError[] = [];

        for (const field of this.collection) {
            field.valid = Validator.doValidate(field, 1, result);
        }

        return result.length === 0 ? null : result;
    }

    public validateField(field: ValidatorInput): boolean {
        field.valid = Validator.doValidate(field, 1, []);

        return field.valid;
    }

    private checkVonBisDate(field: ValidatorInput): void {
        field.valid = true;

        if (this.onlyInRisk.value !== 'alle') {
            return;
        }

        if (field.value && field.value.length > 0) {
            if (!Validator.isDateCorrect(field)) {
                field.errorMsg = Validator.MSG_WRONG_DATE_FORMAT;
                field.valid = false;
            } else if (Validator.isDateInFuture(field)) {
                field.errorMsg = Validator.MSG_DATE_IN_FUTURE;
                field.valid = false;
            }
        } else {
            field.errorMsg = Validator.MSG_ON_REQUIRED_BUT_EMPTY.replace('$_label', field.label);
            field.valid = false;
        }
    }

}
